import { Button, Stack, styled } from "@mui/material";
import React from "react";
import { CheckboxComponent, TextFieldComponent } from "../../external/ensolvers-core-frontend-mui/components/Common/FormComponents";
import GenericForm from "../../external/ensolvers-core-frontend-mui/components/Common/GenericForm";
import { SpinnerWrapper } from "../SpinnerWrapper";
import OpsDialogImage from "../OpsDialogImage";
import FileUploadIcon from "@mui/icons-material/FileUpload";
import Badge from "../../models/Badge";
import { useStyles } from "../Main/formStyles";
import { Token } from "../../theme";

interface Props {
  isLoading: boolean;
  handleUploadImage: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleImageDelete: () => void;
  onClose: () => void;
  handleOnUpdate: (instance: Badge) => void;
  open: boolean;
  selectedFile: string;
  editBadge: Badge;
}

export default function BadgeEditDialog(props: Props) {
  const currentImage = (): string => {
    return props.selectedFile != undefined ? props.selectedFile : props.editBadge?.iconUrl!;
  };

  const customStyles = useStyles();

  if (!props.editBadge) {
    return null;
  }
  return (
    <>
      {props.open ? (
        <GenericForm<Badge>
          headerStyles={{ color: Token.textPrimary, marginBottom: -10, marginTop: 10 }}
          buttonStyles={{ marginRight: 20, color: "white", backgroundColor: Token.actionPrimary, marginBottom: 10 }}
          cancelButtonStyles={{
            color: Token.textSecondary,
            border: `1px solid ${Token.borderDefault}`,
            marginBottom: 10,
          }}
          dialogStyles={customStyles.root}
          dialog={true}
          open={!!props.open}
          instance={props.editBadge}
          title={"Edit Badge"}
          onSave={(instance) => {
            instance.iconUrl = currentImage();
            setTimeout(() => {
              props.onClose();
            }, 500);
            props.handleOnUpdate(instance);
          }}
          onCancel={() => props.onClose()}
          dialogCustomSubmitMessage={"Update"}
          renderContent={(register, errors, control) => (
            <>
              <SpinnerWrapper isLoading={props.isLoading}>
                <OpsDialogImage
                  viewMode={false}
                  selectedFile={props.selectedFile != undefined ? props.selectedFile : props.editBadge?.iconUrl}
                  onDelete={() => props.handleImageDelete()}
                />

                <Stack direction="row">
                  <label htmlFor="contained-button-file">
                    <Input
                      id="contained-button-file"
                      type="file"
                      accept=".jpeg, .jpg, .png, .gif, .bmp"
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) => props.handleUploadImage(e)}
                    />
                    <SpinnerWrapper isLoading={props.isLoading}>
                      <Button startIcon={<FileUploadIcon />} variant="contained" component="span" sx={{ margin: ".7em" }}>
                        Choose Image
                      </Button>
                    </SpinnerWrapper>
                  </label>
                </Stack>

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"name"}
                  label="Title"
                  required={true}
                  size="small"
                />

                <TextFieldComponent
                  control={control}
                  register={register}
                  errors={errors}
                  propertyName={"description"}
                  label="Description"
                  required={true}
                  internalProps={{ multiline: true, rows: 6 }}
                  size="small"
                />

                <CheckboxComponent
                  propertyName={"automaticApproval"}
                  label={"Automatic Approval"}
                  control={control}
                  register={register}
                  errors={errors}
                />
                <CheckboxComponent propertyName={"level"} label={"Level Option"} control={control} register={register} errors={errors} />
              </SpinnerWrapper>
            </>
          )}
        />
      ) : null}
    </>
  );
}
const Input = styled("input")({
  display: "none",
});
